<div *ngIf="fields">
  <form [formGroup]="form">
    <div *ngFor="let key of formFilters; let last = last">
      <div [formGroupName]="key">

        <div class="filter-header">
          <app-filter-builder-field-select [fields]="fields" [fieldControl]="form.get([key, 'field'])"
            (selectionChange)="onFilterFieldChanged($event, key)">
          </app-filter-builder-field-select>

          <mat-form-field class="ml-2 operator-field" *ngIf="getFieldGroupValue(key)?.value">
            <mat-label>{{ 'filterOperator' | translate }}</mat-label>
            <mat-select formControlName="operator" (selectionChange)="onFilterOperatorChanged($event, key)">
              <mat-option *ngFor="let operatorType of getFieldOperators(getFieldGroupValue(key).value)" [value]="operatorType">
                {{ operatorType | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <button *ngIf="!readOnlyMode" (click)="removeFilter(key)" mat-icon-button color="sims" type="button"
            matTooltip="{{ 'removeFilter' | translate }}">
            <mat-icon svgIcon="remove_circle_outline"></mat-icon>
          </button>

          <button *ngIf="!readOnlyMode && selectedRows !== null" (click)="copyValuesFromSelection(key)" mat-icon-button color="sims" type="button"
            [disabled]="!canCopyFromSelection(key)"
            matTooltip="{{ 'copyValuesFromSelection' | translate }}">
            <mat-icon svgIcon="enter" style="transform: scaleX(-1);"></mat-icon>
          </button>
        </div>

        <div class="filter-values" *ngIf="getFieldGroupValue(key)?.value">

          <ng-container [ngSwitch]="getFieldGroupValue(key).value.type">
            <ng-container *ngSwitchCase="'datetime'">
              <ng-container *ngIf="getFieldGroupOperator(key).value === 'equals'; else dateRangeForm">
                <ng-container *ngFor="let arrayControl of getFieldGroupArray(key).controls; let idx = index; let last = last">
                  <div>
                    <mat-form-field (click)="datetimePicker.open()"
                      [class.mat-form-field-invalid]="arrayControl.invalid && arrayControl.touched">
                      <mat-label>{{ 'value' | translate }}</mat-label>
                      <input class="hidden-input" [formControl]="$any(arrayControl)" [ngxMatDatetimePicker]="datetimePicker"
                        (ngModelChange)="onDateArrayValueChanged($event, key, idx, getFieldGroupValue(key).value.type)">
                      <input matInput [value]="arrayControl.value === null ? null : getFormattedDateForFieldType(arrayControl.value, getFieldGroupValue(key).value.type)"
                        autocomplete="off" class="cursor-pointer" [readonly]="true">
                      <mat-datepicker-toggle matSuffix [for]="datetimePicker"></mat-datepicker-toggle>
                      <ngx-mat-datetime-picker #datetimePicker [showSpinners]="true" [showSeconds]="true" [stepHour]="1"
                        [stepMinute]="1" [stepSecond]="1" [touchUi]="true" [hideTime]="false" [appAutoConfirm]="true">
                      </ngx-mat-datetime-picker>
                    </mat-form-field>
                    <button *ngIf="getFieldGroupArray(key).controls.length > 1" (click)="removeArrayElement(key, idx)"
                      mat-icon-button color="sims" class="ml-2" type="button" matTooltip="{{ 'removeValue' | translate }}">
                      <mat-icon svgIcon="highlight_off"></mat-icon>
                    </button>
                    <button *ngIf="last" (click)="addDatetimeArrayElement(key)" mat-icon-button color="sims"
                      class="ml-2" type="button" matTooltip="{{ 'addValue' | translate }}">
                      <mat-icon svgIcon="add_circle_outline"></mat-icon>
                    </button>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'date'">
              <ng-container *ngIf="getFieldGroupOperator(key).value === 'equals'; else dateRangeForm">
                <ng-container *ngFor="let arrayControl of getFieldGroupArray(key).controls; let idx = index; let last = last">
                  <div>
                    <mat-form-field (click)="datePicker.open()"
                      [class.mat-form-field-invalid]="arrayControl.invalid && arrayControl.touched">
                      <mat-label>{{ 'value' | translate }}</mat-label>
                      <input class="hidden-input" [formControl]="$any(arrayControl)" [ngxMatDatetimePicker]="datePicker"
                        (ngModelChange)="onDateArrayValueChanged($event, key, idx, getFieldGroupValue(key).value.type)">
                      <input matInput [value]="arrayControl.value === null ? null : getFormattedDateForFieldType(arrayControl.value, getFieldGroupValue(key).value.type)"
                        autocomplete="off" class="cursor-pointer" [readonly]="true">
                      <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                      <ngx-mat-datetime-picker #datePicker [showSpinners]="true" [showSeconds]="true" [stepHour]="1"
                        [stepMinute]="1" [stepSecond]="1" [touchUi]="true" [hideTime]="true" [appAutoConfirm]="true">
                      </ngx-mat-datetime-picker>
                    </mat-form-field>
                    <button *ngIf="getFieldGroupArray(key).controls.length > 1" (click)="removeArrayElement(key, idx)"
                      mat-icon-button color="sims" class="ml-2" type="button" matTooltip="{{ 'removeValue' | translate }}">
                      <mat-icon svgIcon="highlight_off"></mat-icon>
                    </button>
                    <button *ngIf="last" (click)="addDateArrayElement(key)" mat-icon-button color="sims"
                      class="ml-2" type="button" matTooltip="{{ 'addValue' | translate }}">
                      <mat-icon svgIcon="add_circle_outline"></mat-icon>
                    </button>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>

            <ng-template #dateRangeForm>
              <mat-form-field (click)="startPicker.open()">
                <mat-label>{{ (getFieldGroupOperator(key).value === 'equals' ? 'value' : 'from') | translate }}</mat-label>
                <input class="hidden-input" formControlName="start" [min]="minDate" [max]="maxDate" [ngxMatDatetimePicker]="startPicker"
                  (ngModelChange)="onDateValueChanged($event, key, 'start', getFieldGroupValue(key).value.type)">
                <input matInput formControlName="startToShow" autocomplete="off" class="cursor-pointer" [readonly]="true">
                <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                <ngx-mat-datetime-picker #startPicker [showSpinners]="true" [showSeconds]="true" [stepHour]="1" [stepMinute]="1" [stepSecond]="1"
                  [touchUi]="true" [hideTime]="getFieldGroupValue(key).value.type == 'date'"
                  [appAutoConfirm]="true">
                </ngx-mat-datetime-picker>
              </mat-form-field>
              <mat-form-field *ngIf="getFieldGroupOperator(key).value !== 'equals'" class="ml-2" (click)="endPicker.open()">
                <mat-label>{{ 'to' | translate }}</mat-label>
                <input class="hidden-input" formControlName="end" [min]="minDate" [max]="maxDate" [ngxMatDatetimePicker]="endPicker"
                  (ngModelChange)="onDateValueChanged($event, key, 'end', getFieldGroupValue(key).value.type)">
                <input matInput formControlName="endToShow" autocomplete="off" class="cursor-pointer" [readonly]="true">
                <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                <ngx-mat-datetime-picker #endPicker [showSpinners]="true" [showSeconds]="true" [stepHour]="1" [stepMinute]="1" [stepSecond]="1"
                  [touchUi]="true" [hideTime]="getFieldGroupValue(key).value.type == 'date'"
                  [appAutoConfirm]="true">
                </ngx-mat-datetime-picker>
              </mat-form-field>
            </ng-template>

            <ng-container *ngSwitchCase="'time'">
              <mat-form-field>
                <mat-label>{{ 'from' | translate }}</mat-label>
                <input matInput formControlName="start" [value]="form.get(key).get('start').value" placeholder="00:00" type="time"
                  autocomplete="off">
              </mat-form-field>
              <mat-form-field class="ml-2">
                <mat-label>{{ 'to' | translate }}</mat-label>
                <input matInput formControlName="end" [value]="form.get(key).get('end').value" placeholder="00:00" type="time"
                  autocomplete="off">
              </mat-form-field>
            </ng-container>

            <ng-container *ngSwitchCase="'boolean'">
              <ng-container *ngFor="let arrayControl of getFieldGroupArray(key).controls; let idx = index; let last = last">
                <div>
                  <mat-form-field>
                    <mat-label>{{ 'value' | translate }}</mat-label>
                    <mat-select [formControl]="$any(arrayControl)">
                      <mat-option [value]="true">{{ 'yes' | translate }}</mat-option>
                      <mat-option [value]="false">{{ 'no' | translate }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <button *ngIf="getFieldGroupArray(key).controls.length > 1 && isMultiValueOperator(getFieldGroupOperator(key).value)" (click)="removeArrayElement(key, idx)"
                    mat-icon-button color="sims" class="ml-2" type="button" matTooltip="{{ 'removeValue' | translate }}">
                    <mat-icon svgIcon="highlight_off"></mat-icon>
                  </button>
                  <button *ngIf="last && isMultiValueOperator(getFieldGroupOperator(key).value)" (click)="addBooleanArrayElement(key)" mat-icon-button color="sims"
                    class="ml-2" type="button" matTooltip="{{ 'addValue' | translate }}">
                    <mat-icon svgIcon="add_circle_outline"></mat-icon>
                  </button>
                </div>
              </ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="'area'">
              <div class="area-type-container">
                <input matInput [formControl]="getFieldGroupArray(key).controls[0]" class="hidden-input">
                <span *ngIf="currentDrawingPolygonKey == key; then drawControlButtons else drawButton"></span>
                <ng-template #drawControlButtons>
                  <button mat-raised-button color="white" (click)="cancelDrawPolygon(key)">
                    {{ 'cancel' | translate }}
                  </button>
                  <button mat-raised-button color="white" (click)="confirmDrawPolygon(key)" class="ml-3">
                    {{ 'confirm' | translate }}
                  </button>
                </ng-template>
                <ng-template #drawButton>
                  <button mat-raised-button color="white" (click)="drawPolygon(key)">
                    <mat-icon svgIcon="icon_draw_polygon"></mat-icon>
                    {{ 'draw' | translate }}
                  </button>
                </ng-template>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'violation-with-status'">
              <ng-container *ngIf="getFieldGroupOperator(key).value != 'isNull' && getFieldGroupOperator(key).value != 'notNull'">
                <ng-container *ngFor="let arrayControl of getFieldGroupArray(key).controls; let idx = index; let last = last">
                  <div>
                    <app-filter-builder-violation-with-status-field [fieldControl]="arrayControl"></app-filter-builder-violation-with-status-field>
                    <ng-container *ngIf="isMultiValueOperator(getFieldGroupOperator(key).value)">
                      <button *ngIf="getFieldGroupArray(key).controls.length > 1" (click)="removeArrayElement(key, idx)" mat-icon-button
                        color="sims" class="ml-2" type="button" matTooltip="{{ 'removeValue' | translate }}">
                        <mat-icon svgIcon="highlight_off"></mat-icon>
                      </button>
                      <button *ngIf="last" (click)="addArrayElement(key)" mat-icon-button color="sims" class="ml-2" type="button"
                        matTooltip="{{ 'addValue' | translate }}">
                        <mat-icon svgIcon="add_circle_outline"></mat-icon>
                      </button>
                    </ng-container>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>

            <ng-container *ngSwitchDefault>
              <ng-container
                *ngIf="getFieldGroupOperator(key).value == 'isNull' || getFieldGroupOperator(key).value == 'notNull'; else showBetweenOrField">
                <input matInput [formControl]="getFieldGroupArray(key).controls[0]" class="hidden-input">
              </ng-container>
              <ng-template #showBetweenOrField>
                <ng-container *ngIf="isBetweenOperator(getFieldGroupOperator(key).value); else showField">
                  <mat-form-field>
                    <mat-label>{{ 'from' | translate }}</mat-label>
                    <input matInput formControlName="start" autocomplete="off">
                  </mat-form-field>
                  <mat-form-field class="ml-2">
                    <mat-label>{{ 'to' | translate }}</mat-label>
                    <input matInput formControlName="end" autocomplete="off">
                  </mat-form-field>
                </ng-container>
                <ng-template #showField>
                <ng-container *ngFor="let arrayControl of getFieldGroupArray(key).controls; let idx = index; let last = last">
                  <div>
                    <!-- Lista wartości z wczytanych danych wygrywa z widgetem listy dociąganej z serwera -
                         pokazuje to, co realnie jest w tabeli, na którą patrzy użytkownik. -->
                    <ng-container *ngIf="!isListFieldType(key) || getFieldOptions(key); else showList">
                      <mat-form-field>
                        <mat-label>{{ 'value' | translate }}</mat-label>
                        <span *ngIf="!getFieldOptions(key); then showInput else showSelect"></span>
                        <ng-template #showInput>
                          <input matInput [formControl]="getFieldGroupArray(key).controls[idx]"
                            [value]="getFieldGroupArray(key).controls[idx].value" autocomplete="off">
                        </ng-template>
                        <ng-template #showSelect>
                          <mat-select [formControl]="getFieldGroupArray(key).controls[idx]">
                            <mat-select-trigger *ngIf="getSelectedOption(key, idx) as selectedOpt">
                              <div *ngIf="selectedOpt.isHtml else selectedTextOption" [innerHtml]="selectedOpt.value"></div>
                              <ng-template #selectedTextOption>{{ selectedOpt.value | translate }}</ng-template>
                            </mat-select-trigger>
                            <mat-option *ngFor="let option of getFieldOptions(key)" [value]="option.key">
                              <div *ngIf="option.isHtml else showTextOption" [innerHtml]="option.value"></div>
                              <ng-template #showTextOption>
                                {{ option.value | translate }}
                              </ng-template>
                            </mat-option>
                          </mat-select>
                        </ng-template>
                      </mat-form-field>
                    </ng-container>
                    <ng-template #showList>
                      <app-filter-builder-list-field [fieldControl]="arrayControl"
                        [fieldType]="getListFieldType(key)"></app-filter-builder-list-field>
                    </ng-template>

                    <ng-container *ngIf="shouldAllowVehicleGroupsEditing() && getFieldGroupValue(key).value.type === 'vehicleGroup'">
                      <button (click)="openVehicleGroupDialog()" mat-icon-button color="sims" class="ml-2" type="button"
                        matTooltip="{{ 'newOrEditVehicleGroup' | translate }}">
                        <mat-icon svgIcon="add_or_edit"></mat-icon>
                      </button>
                    </ng-container>

                    <ng-container
                      *ngIf="isMultiValueOperator(getFieldGroupOperator(key).value) && getFieldGroupValue(key).value.type !== 'vehicleGroup'">
                      <button *ngIf="getFieldGroupArray(key).controls.length > 1" (click)="removeArrayElement(key, idx)" mat-icon-button
                        color="sims" class="ml-2" type="button" matTooltip="{{ 'removeValue' | translate }}">
                        <mat-icon svgIcon="highlight_off"></mat-icon>
                      </button>
                      <button *ngIf="last" (click)="addArrayElement(key)" mat-icon-button color="sims" class="ml-2" type="button"
                        matTooltip="{{ 'addValue' | translate }}">
                        <mat-icon svgIcon="add_circle_outline"></mat-icon>
                      </button>
                    </ng-container>
                  </div>
                </ng-container>

                </ng-template>
              </ng-template>
            </ng-container>
          </ng-container>

        </div>
      </div>
      <mat-divider *ngIf="!last" class="mt-1 mb-3"></mat-divider>
    </div>
  </form>
  <div class="pt-3">
    <button *ngIf="!readOnlyMode" mat-raised-button color="sims" (click)="addFilter()">
      {{ 'addFilter' | translate }}
    </button>
  </div>
  <div class="filter-error-alert" *ngIf="form.errors">
    <mat-icon class="filter-error-alert-icon" svgIcon="warning"></mat-icon>
    <div class="filter-error-alert-messages">
      <ng-container *ngFor="let error of formErrors">
        <div [translate]="error" [translateParams]="{value: form.errors[error]}"></div>
      </ng-container>
    </div>
  </div>
</div>
